// Global JavaScript for Shopify theme

// Update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const count = cart.item_count || 0;
      const countElements = document.querySelectorAll('#cart-count, #cart-count-mobile');
      countElements.forEach(el => {
        if (el) {
          el.textContent = count;
          if (count > 0) {
            el.style.display = 'inline-flex';
            el.classList.add('animate');
            setTimeout(() => el.classList.remove('animate'), 300);
          } else {
            el.style.display = 'none';
          }
        }
      });
    })
    .catch(err => console.error('Error fetching cart:', err));
}

// Initialize cart count on load
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
});

// Listen for cart updates
document.addEventListener('cart:updated', updateCartCount);

